import geohash from 'geo-hash'

export const getMapCenter = function (arr) {

  //
  let latArr = []
  let lngArr = []

  //
  for (let i in arr) {

    // check if pic has geohash.
    if (arr[i].hasGeohash) {

      // if so, get geohash
      let decodedPos = geohash.decode(arr[i].shareSpotLocation.geohash)
      //
      /* let pos = {
        lat: decodedPos.lat,
        lng: decodedPos.lon
      } */
      //
      latArr.push(decodedPos.lat)
      lngArr.push(decodedPos.lon)
      //
      let maxLat = Math.max(...latArr)
      let minLat = Math.min(...latArr)
      //
      let maxLng = Math.max(...lngArr)
      let minLng = Math.min(...lngArr)
      //
      let avgLat = (maxLat + minLat)/2
      let avgLng = (maxLng + minLng)/2
      //
      return {
        avgLat: avgLat,
        avgLng: avgLng,
        //
        maxLat,
        minLat,
        maxLng,
        minLng
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helper/getMapCenter.js